"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.attachErrorHandler = void 0;
var core_1 = require("./core");
/**
 * Attaches an error listener to the vue app, calling all previous handlers as well
 * @param  {Vue} app
 */
var attachErrorHandler = function (app) {
    var errorHandler = app.config.errorHandler;
    // we need to reassign the param to override the listener
    // eslint-disable-next-line no-param-reassign
    app.config.errorHandler = function (error, vm, lifecycleHook) {
        (0, core_1.sendErrorToNoibu)(error);
        if (typeof errorHandler === 'function') {
            errorHandler.call(app, error, vm, lifecycleHook);
        }
    };
};
exports.attachErrorHandler = attachErrorHandler;
